import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const SubscriptionContext = createContext(null);

const PRO_PLANS = ["teacher_pro", "program_10", "program_25", "program_custom"];

export function SubscriptionProvider({ children }) {
  const { user } = useAuth();
  const [planId, setPlanId] = useState("free_trial");
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!user) { setLoading(false); return; }
    try {
      const { data } = await api.get("/subscription/me");
      setPlanId(data.plan_id || "free_trial");
    } catch { /* ignore */ }
    finally { setLoading(false); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  // Coaches & admins always have full access; teachers need a Pro/Program plan.
  const hasPro = user?.role === "admin" || user?.role === "coach" || PRO_PLANS.includes(planId);

  return (
    <SubscriptionContext.Provider value={{ planId, hasPro, loading, refresh }}>
      {children}
    </SubscriptionContext.Provider>
  );
}

export const useSubscription = () => useContext(SubscriptionContext);
